import React from 'react';
import useTransmise from '../../Hooks/useTransmise';
import useFlatData from '../../../Base/Hooks/useFlatData';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
// @ts-ignore
import styles from './TransmiseList.module.scss';
import DASTAListItem from '../DASTAListItem/DASTAListItem';

const wrapperId = 'transmiseListWrapper';

interface Props {
	patientId: string;
}

const TransmiseList: React.FC<Props> = ({ patientId }) => {
	const { getFlatTransmiseList, getNextPage, data, isLoading, page, setPage } =
		useTransmise();

	const { flatData, hasMoreData, loadData } = useFlatData(
		getFlatTransmiseList,
		{
			data: data?.transmiseList?.data,
			totalPages: data?.transmiseList?.meta?.totalPages,
			page: data?.transmiseList?.meta?.page,
		},
		page,
		setPage,
		{
			userId: patientId,
			dateFrom: '2023-01-01',
			dateTo: '2025-02-27',
		},
	);

	return (
		<div className={styles.wrapper}>
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => <DASTAListItem item={item} />}
				/>
			</ScrollContainer>
		</div>
	);
};

export default TransmiseList;
